module.exports = __webpack_public_path__ + "img/incorrect_btn.e59edf27.png";